import React, { useEffect } from 'react'
import { BodyText, LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'

export const DigitalWallet = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <SavingsWrapper>
    <SavingsHeader>
          <LeftSection>
          <h3>
                A digital wallet that allows you save, withdraw, transfer and manage your funds for free and at will
          </h3>
          </LeftSection>
          <RightSection>
              <img src="img/Group 8614 (1).svg" alt="couple saving in  bottle" />
          </RightSection>
      </SavingsHeader>
      </SavingsWrapper>
  )
}